import cn from 'classnames';
import { Form, Layout, Localization } from 'connex-cds';
import React from 'react';
import styled from 'styled-components';
import style from '../style';

const { Column, Row, Container } = Layout;
const { Translate } = Localization;

const Styled = styled.div`
  ${style}
`;

export const TotalPumpedQuantityDesktop = ({ mixInfo, primaryLineItem }) => {
  const {
    Components: { TotalPumpedQuantity },
  } = Form.useFormContext();

  return (
    <Styled className={cn('returned-materials')}>
      <Column>
        <Row>
          <Container flex={1}>
            <Column>
              <div className="body">
                <Translate stringId="productIdLabel" data-testid="mixIdDescriptionLabel" /> :{' '}
                <span data-testid="mixIdDescriptionValue"> {mixInfo.mix} </span>
              </div>
            </Column>
          </Container>
        </Row>
        <Row>
          <Column>
            <TotalPumpedQuantity uomCode={primaryLineItem?.quantity?.uomCode} />
          </Column>
        </Row>
      </Column>
    </Styled>
  );
};
